define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var _ = require('underscore');
    // var app = require('app');

    return Marionette.ItemView.extend({
        template: '<span class="badge badge-important js-header-tasks-count">{{#if number}} {{ number }} {{/if}}</span>',
        className: 'fa fa-check-square-o js-btn-tasks',

        initialize: function () {
            this.model = new Backbone.Model();
            this.listenTo(this.model, 'change:number', this.render);
            this.listenTo(app.Models.Counters, 'change:due_tasks', this.updateCount);
            this.model.set('number', +(app.Models.Counters.get('due_tasks') || 0));
        },

        updateCount: function (model, value) {
            if(this.model.get('number') != value) {
                this.model.set('number', value);
                this.render();
            }

        }


    });
});